export const getOnboardingMeetingLink = (email?: string) =>
  `https://book.sparklayer.io/${email ? `?email=${encodeURIComponent(email)}` : ''}`;
